export default __webpack_public_path__ + "images/670bb194e55f144606103d2c1e36d151-bridal.jpg";